/**
 * FRONT EIOVISUAL
 */
 
// _______________________________________________________

import LazyLoad from 'vanilla-lazyload';
import '../src/DocReady.js';

// _______________________________________________________

window.is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
window.is_Edge = navigator.userAgent.indexOf("Edge") > -1;
window.is_chrome = !!window.chrome && !is_opera && !is_Edge;
window.is_explorer= typeof document !== 'undefined' && !!document.documentMode && !is_Edge;
window.is_firefox = typeof window.InstallTrigger !== 'undefined';
window.is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// _______________________________________________________

// FONT
import('typeface-raleway')
    .then((Module) => {});;

// _______________________________________________________

/**
 * GLOBAL SCROLLMAGIC E GSAP
 */

import {TimelineMax,TweenMax, gsap, Power4} from "gsap";  // Also works with TweenLite and TimelineLite: import { TweenMax, TimelineMax } from "gsap";
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
// import TweenMax from 'gsap/src/uncompressed/TweenMax';
// import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

window.TimelineMax = TimelineMax;
window.ScrollMagic = ScrollMagic;
window.Power4 = Power4;
window.gsap = gsap;
// window.ScrollMagicPluginGsap = ScrollMagicPluginGsap;

// _______________________________________________________

/**
 * ASYNC MODULES
 */

/**
 * Per ogni modules
 * effettua un lazyload sul modulo
 * se questo non è già stato caricato precedentemente
 */

var lazyloadModulesLoaded = [];
var lazyloadModules = [
    'block-cover',
    'block-half',
    'block-icone',
    'block-title',
    'block-steps',
    'block-loghi',
    'block-accordion',
    'block-loghi-noslider',
    'block-titolo-testo-immagine',
    'block-blog-cover',

    // 'block-cover-interna',
    // 'block-cover-minima',
    // 'block-contacts',
    // 'block-prodotti-riquadri',
    // 'block-collezioni-slider',
    // 'block-testo-su-immagine',
    // 'block-titolo-testo-1',
    // 'block-content-bottiglie',
    // 'block-content-slider',
    // 'block-content-slider-alt2',
    // 'block-content-slider-esterno',
    // 'block-newsletter',
    // 'block-gallery-4',
    // 'block-testo-grande',
    // 'block-titolo-testo-immagine',
    // 'block-titolo-testo-bottiglie',
    // 'block-titolo-testo-bottiglia-half',
    // 'block-prodotti-confronto',
    // 'block-on-off',
    // 'block-on-off-animated',
    // 'block-wysiwyg'
];

lazyloadModules.forEach((module) => {

    new LazyLoad({
        elements_selector: '.' + module,
        callback_enter: function (el) {

            // se il modulo non è ancora stato caricato, lo importa
            if(!lazyloadModulesLoaded.includes(module)) {

                // async load module
                import(
                    /* webpackPrefetch: true */
                    './' + module + '/module.js'
                ).then((Module) => {});
        
                lazyloadModules.push(module);   // set module as loaded

            } // does include?
        } // callback enter
    }); // new lazy

});

// _____________________________________________________________________________________

// Style
// import './index.scss';
import(
    /* webpackPrefetch: true */
    './index.scss'
    /* webpackChunkName: "async.eiovisual" */
);

// _____________________________________________________________________________________

// LAZYLOAD PLACEHOLDER

/**
 * figure .placeholder .figure
 * img .lazy
 * /figure
 */

// lazy load placeholder
DocReady(() => {

    // tutte le immagini .lazy
    const $images = document.querySelectorAll('img.lazy');

    // per ogni immagine .lazy gestisce il loading con o senza placeholder
    $images.forEach(($image) => {

        // settings
        let datasrc = $image.getAttribute('data-src');
        let h = parseInt($image.getAttribute('height')) ?? 1;
        let w = parseInt($image.getAttribute('width')) ?? 1;
        
        // verifica se il parent è di tipo placeholder
        var $figure = $image.parentNode;
        $image.has_placeholder = $figure.classList.contains('lazy-placeholder') && w > 0 && h > 0;

        // SCENARIO 1
        // c'è un placeholder
        if($image.has_placeholder) {

            if($image.classList.contains('img-fluid')) { // se l'immagine è responsive, usa padding percentuale e larghezza 100%

                $figure.style.paddingBottom = (Math.floor((h / w) * 100)).toString() + '%';
                $figure.style.width = '100%';
            
            } else { // se l'immagine non è responsive usa larghezza statica, e padding pari ad altezza
                
                $figure.style.paddingBottom = h.toString() + 'px';
                $figure.style.width = w.toString() + 'px';

            }
        }
        
    });
});

// _____________________________________________________________________________________

// lazy load loader
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
    threshold: 0,
    load_delay: 0,
    // use_native: true,
    callback_enter: function($el) {
        $el.parentNode.classList.add('loaded');
    }
});

// _____________________________________________________________________________________